import { withChartLayout } from 'components/common';
import PainInterventions from 'components/features/chart/system-nursing-interventions/pain-interventions/PainInterventions';

const PainInterventionsPage = withChartLayout('Pain Interventions')(PainInterventions);
export default PainInterventionsPage;
